const graphDataCalculator = async (response, userAttemptCount, userAnswerCount) => {
  const calculatedGraphData = [];
  for (let iterator = 0; iterator < response.length; iterator++) {
    const rightAnswered = response[iterator][userAnswerCount];
    const totalQuestion = response[iterator][userAttemptCount];
    const userGraphValues = parseInt((rightAnswered / totalQuestion) * 100, 10) || 0;

    await calculatedGraphData.push(userGraphValues);
  }
  return calculatedGraphData;
};
export default graphDataCalculator;



// WEBPACK FOOTER //
// ./src/common/graphDataCalculator.js